// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.ChevronDown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.ChevronDown = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var ChevronDown = _exports.ChevronDown = function ChevronDown(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M9.99924 13.7073C9.85061 13.7073 9.70196 13.6508 9.58894 13.537L4.17011 8.11757C3.9433 7.89073 3.9433 7.52295 4.17011 7.29611C4.39693 7.06927 4.76466 7.06927 4.99148 7.29611L10 12.3052L15.0085 7.29611C15.2353 7.06927 15.6031 7.06927 15.8299 7.29611C16.0567 7.52295 16.0567 7.89073 15.8299 8.11757L10.4111 13.537C10.2965 13.6508 10.1479 13.7073 9.99924 13.7073Z",
      fill: "#212B36"
    }));
  };
});
